module.exports = __webpack_public_path__ + "img/insurance-logo-14.a0aa3c19.png";